// 稽古の6点 (2026-10-28 初見の AI の試遊で出た6つの引っかかり)。DEV ?tut6=all か ?tut6=1,3,5 のように点の番号で入れ替えて比べる (?tut6=none で全部外す)。
//   配布版の既定 = ①②③⑤ (10-31 作者の答え「入れる」)。⑥は「今のまま」で入れない。
//   ④は札の「いま」を消した (作者「いまも、今押すもいらない」) ので、ここでは切り替えない＝render.ts は何も見ない。
//   URL は game.ts の DEV の箱の中だけで読む。
//   記録 = docs/research/2026-10-30-tutorial-six-points.md
//   ① 課題を抜けた時、抜けた課題の印が3つとも埋まった姿を一拍見せてから次へ (今は3つ目が埋まる前に次の課題へ替わる)。
//   ② 5つ目 (回避カウンター) の課題の文を短く。
//   ③ 波の場面で止めるのを、床に波が見えてから (今は予告が始まってすぐ止まり、波がまだ見えない)。
//   ④ 止めた札の「いま」を消す (10-31 作者「いまも、今押すもいらない」・tut_focus.ts の札から外した)。
//   ⑤ 主人公が左右の壁際に追い込まれたら、亡霊が歩いて下がって間を空ける (今は壁に押し付けたまま)。
//   ⑥ 稽古を終えた勝利画面に「稽古は、ここまで」を足す (今は ACT I FALLS だけで、終わったと分からない)。
export const TUT_SIX_DEFAULT = [1, 2, 3, 5] as const
const enabled = new Set<number>(TUT_SIX_DEFAULT)

export function setTutSix(value: string | null | undefined): number[] {
  enabled.clear()
  if (value == null || value === '') TUT_SIX_DEFAULT.forEach((n) => enabled.add(n))
  else if (value === 'all') [1, 2, 3, 4, 5, 6].forEach((n) => enabled.add(n))
  else for (const s of (value ?? '').split(',')) {
    const n = Number(s)
    if (Number.isInteger(n) && n >= 1 && n <= 6) enabled.add(n)
  }
  return [...enabled].sort()
}

export function tutSix(n: 1 | 2 | 3 | 4 | 5 | 6): boolean {
  return enabled.has(n)
}

export const TUT_SIX = {
  /** ① 抜けた課題の印を見せておく秒。カードの稽古のクリアの間 (TIPS_CARD_HOLD_MS 900ms) と同じ長さ。 */
  clearShowSec: 0.9,
  /** ② 5つ目の課題の文。 */
  counterGoal: '赤黒いオーラは {step} で回避 ― 直後に {attack} で回避カウンター',
  /** ③ 予告のこの割合が過ぎてから止める (波が床に描かれ始めてから)。抜けられる向きが無ければ止めないのは今のまま。 */
  zoneShowAfter: 0.4,
  /** ③ この ms 先で抜けられなくなるなら、0.4 を待たずにいま止める。 */
  zoneLeadMs: 100,
  /** ⑤ 主人公が壁からこの距離 (px) の内にいたら、亡霊は下がる。 */
  wallNearPx: 120,
  /** ⑤ 亡霊が下がり切る、二人の間の距離 (px)。攻撃を出せる間合い BOSS.attackCommitRange (185) より内側に置く
   *   (10-31: 300 だと壁際で動かない主人公へ二度と攻撃を出さず、稽古が先へ進まなかった)。 */
  roomPx: 170,
  /** ⑥ 勝利画面の一行。 */
  doneLine: '稽古は、ここまで',
}

/** ⑤ 壁際に追い込まれた主人公の前から、亡霊が歩いて下がった後の x。下がらない時はそのまま返す。 */
export function tutWallRoomX(bossX: number, playerX: number, bounds: { leftWall: number; rightWall: number },
  walkPx: number): number {
  const nearLeft = playerX - bounds.leftWall < TUT_SIX.wallNearPx
  const nearRight = bounds.rightWall - playerX < TUT_SIX.wallNearPx
  if (!nearLeft && !nearRight) return bossX
  // 主人公と壁の間に亡霊がいる (回り込まれた) 時は動かさない = 下がると壁へ寄るだけ。
  const away = nearLeft ? 1 : -1
  if (Math.sign(bossX - playerX) !== away) return bossX
  if (Math.abs(bossX - playerX) >= TUT_SIX.roomPx) return bossX
  return Math.max(bounds.leftWall, Math.min(bounds.rightWall, bossX + away * walkPx))
}
